import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router';
import { api, errorMessage } from '../../api/client';
import { MACHINES_KEY } from '../machines/MachineActions';
import { offlineHint } from '../machines/hardware';
import { ArchivePanel } from './ArchivePanel';
import { CatalogPanel } from './CatalogPanel';
import { CloudPanel } from './CloudPanel';
import { CloudPodPanel } from './CloudPodPanel';
import { DownloadsPanel } from './DownloadsPanel';
import { FilesPanel } from './FilesPanel';
import { LogsPanel } from './LogsPanel';
import { ModelsPanel } from './ModelsPanel';
import { NodePacksPanel } from './NodePacksPanel';
import { StatusPanel } from './StatusPanel';

export function MachinePage() {
  const { id = '' } = useParams();
  const machines = useQuery({ queryKey: MACHINES_KEY, queryFn: api.listMachines, refetchInterval: 10_000 });
  const machine = machines.data?.machines.find((m) => m.id === id);
  if (machines.isPending) return <p role="status">Loading…</p>;
  if (machines.isError) return <p role="alert" className="form-error">{errorMessage(machines.error)}</p>;
  if (!machine) return <p className="notice">This machine does not exist (any more). <Link to="/">Back to My machines</Link></p>;
  return (
    <section aria-labelledby="machine-title">
      <p><Link to="/">← My machines</Link></p>
      <div className="page-head">
        <h1 id="machine-title">{machine.name}</h1>
        <span className={`state ${machine.online ? 'state-online' : 'state-offline'}`}>{machine.online ? 'Online' : 'Offline'}</span>
      </div>
      {machine.cloudPodId && <CloudPodPanel machine={machine} podId={machine.cloudPodId} />}
      {machine.hardware?.cloud && <CloudPanel machine={machine} cloud={machine.hardware.cloud} />}
      <ArchivePanel machine={machine} />
      {machine.online ? (
        <>
          <StatusPanel machineId={id} />
          <CatalogPanel machineId={id} />
          <DownloadsPanel machineId={id} />
          <ModelsPanel machineId={id} />
          <FilesPanel machineId={id} />
          <NodePacksPanel machineId={id} />
          <LogsPanel machineId={id} />
        </>
      ) : (
        <p className="notice">
          {offlineHint(machine)}
        </p>
      )}
    </section>
  );
}
